export default {
    state: {
        wallets: undefined
    },
    getters: {
        wallets: state => state.wallets
    },
    mutations: {
        wallets(state, wallets) {
            console.log(wallets);
            state.wallets = wallets;
        }
    }
}